import { createConfig, createConnector, http } from "wagmi";
import { injected } from "wagmi/connectors";
import { base } from "wagmi/chains";
import { QueryClient } from "@tanstack/react-query";
import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import {
    metaMaskWallet,
    coinbaseWallet,
    rabbyWallet,
    injectedWallet,
    walletConnectWallet,
    rainbowWallet,
    trustWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { RPC_URL, WALLETCONNECT_PROJECT_ID } from "./config";

/*
 * RainbowKit's MetaMask wallet routes the desktop extension through the MetaMask SDK, which can leave the modal
 * stuck on "Opening MetaMask..." without ever showing the extension popup. When the extension is installed, talk to
 * it directly as an injected provider instead; without it, keep RainbowKit's QR / mobile deep-link flow.
 */
const metaMaskExtensionWallet = (params) => {
    const wallet = metaMaskWallet(params);
    if (!wallet.installed) return wallet;
    return {
        ...wallet,
        createConnector: (walletDetails) =>
            createConnector((config) => ({
                ...injected({ target: "metaMask" })(config),
                ...walletDetails,
            })),
    };
};

/*
 * Wallets offered by the RainbowKit modal. Browser wallets need nothing else; mobile wallets connect over
 * WalletConnect, which needs a project ID, so they are only offered when one is configured.
 */
const browserWallets = [metaMaskExtensionWallet, coinbaseWallet, rabbyWallet, injectedWallet];
const mobileWallets = WALLETCONNECT_PROJECT_ID ? [walletConnectWallet, rainbowWallet, trustWallet] : [];

const connectors = connectorsForWallets(
    [
        { groupName: "Browser wallets", wallets: browserWallets },
        ...(mobileWallets?.length ? [{ groupName: "Mobile wallets", wallets: mobileWallets }] : []),
    ],
    {
        appName: "USDX Smart — InsightX",
        // RainbowKit requires a value here; browser wallets never use it, so a placeholder is safe without one
        projectId: WALLETCONNECT_PROJECT_ID || "00000000000000000000000000000000",
    },
);

export const wagmiConfig = createConfig({
    chains: [base],
    connectors,
    transports: {
        [base.id]: http(RPC_URL),
    },
});

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
        },
    },
});
